import { toQueryParams } from "helpers/url";
import appAxios from "./axios";
import { LIMIT } from "data/consts";
import { AxiosResponse } from "axios";

export class BaseService<T> {
  constructor(public basePath: string) { }

  pathWithOrg() {
    const orgID = localStorage.getItem("orgID");
    const path = ["/admin"];
    if (orgID) {
      path.push("orgs", orgID);
    }
    path.push(this.basePath);
    const pathString = path.join("/");
    return pathString;
  }

  getAll = (queryParams: any = {}): Promise<AxiosResponse<any>> => {
    queryParams = {
      ...queryParams,
      limit: queryParams?.limit || LIMIT
    }
    return appAxios.get(this.pathWithOrg() + "?" + toQueryParams(queryParams));
  };
  getAllAndCount = (queryParams: any = {}): Promise<AxiosResponse<{ rows: T[], count: number }>> => {
    queryParams = {
      ...queryParams,
      limit: queryParams?.limit || LIMIT
    }
    return appAxios.get(this.pathWithOrg() + "?" + toQueryParams(queryParams));
  };
  get = (id: any): Promise<T> => appAxios.get(`${this.pathWithOrg()}/${id}`);
  delete = (id: any): Promise<number> => appAxios.delete(`${this.pathWithOrg()}/${id}`);
  post = (data: any, queryParams = {}, isFormData = false): Promise<T> => {
    if (isFormData) {
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value as string | Blob);
      });
      return appAxios.post(`${this.pathWithOrg()}` + "?" + toQueryParams(queryParams), formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    }
    return appAxios.post(`${this.pathWithOrg()}` + "?" + toQueryParams(queryParams), data);
  };
  put = (id: any, data: T): Promise<T> => appAxios.put(`${this.pathWithOrg()}/${id}`, data);
  patch = (id: any, data: T): Promise<T> => appAxios.patch(`${this.pathWithOrg()}/${id}`, data);
}
